module.exports = __webpack_public_path__ + "img/Kraftfahrzeug.9c1de4d4.svg";